import { render } from "./activeOrders.vue?vue&type=template&id=896c1b5c"
import script from "./activeOrders.vue?vue&type=script&lang=js"
export * from "./activeOrders.vue?vue&type=script&lang=js"

import "./activeOrders.vue?vue&type=style&index=0&id=896c1b5c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__